module.exports = __webpack_public_path__ + "img/home.0c92990a.svg";